import { useFragment } from './generated';

export const fragment = useFragment;
